module.exports = __webpack_public_path__ + "static/navigation_f-8aa661c541ee67a1b3d1f571a837fb28.gif";